import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
/**
 * Class description
 *
 * Created: 2017-10-04
 * @author jonas
 */
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline, TimelineLite} from "gsap";
import {TeslaSymbols} from "../../config/TeslaSymbols";
import {TeslaStateReelSymbol} from "../reel/TeslaStateReelSymbol";
import {TeslaGameAssets} from "../TeslaGameAssets";
import {TeslaGameConfig} from "../TeslaGameConfig";
import {StateMatrix} from "./StateMatrix";

export class TeslaSymbolUtil {


    public static getSymbolWinAnimation(symbol:TeslaStateReelSymbol, winRatioConfig:IWinRatioConfig):Timeline | null {
        const symbolAnimation:Timeline | null = symbol.changeState({
            state : TeslaGameConfig.instance.SYMBOL_STATES.win,
            fadeInDuration : 0.1
        });

        if(!symbolAnimation) {
            return null;
        }

        const tl:TimelineLite = new TimelineLite();
        let winEffect:TimelineSprite;

        if(winRatioConfig.type == WinRatioType.TINY) {
            winEffect = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.TINY_EFFECT));
        } else if(winRatioConfig.type == WinRatioType.SMALL) {
            winEffect = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.SMALL_EFFECT));
        } else if(winRatioConfig.type == WinRatioType.MEDIUM) {
            winEffect = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.MEDIUM_EFFECT));
        } else {
            winEffect = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.LARGE_EFFECT));
        }

        winEffect.anchor.set(0.5, 0.5);
        winEffect.hide();
        symbol.addChild(winEffect);

        tl.add(winEffect.getAnimationAutoShowHide(true, true));
        tl.add(symbolAnimation, 0);


        return tl;
    }

    public static getSymbolsNoWinAnimation(coordinates:[number, number][]):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        for(let i:number = 0; i < coordinates.length; i++) {
            const reelIndex:number = coordinates[i][0];
            const symbolIndex:number = coordinates[i][1];
            const symbol:TeslaStateReelSymbol | null = <TeslaStateReelSymbol>Reels.getSymbol(reelIndex, symbolIndex);
            if(symbol != null) {
                let animation:Timeline | null = symbol.changeState({
                    state : TeslaGameConfig.instance.SYMBOL_STATES.noWin,
                    fadeInDuration : 0.0
                });

                if(animation != null) {
                    tl.add(animation, 0);
                }
            }
        }
        return tl;
    }

    public static getSymbolsWinAnimation(coordinates:[number, number][], winRatioConfig:IWinRatioConfig):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        for(let i:number = 0; i < coordinates.length; i++) {
            const reelIndex:number = coordinates[i][0];
            const symbolIndex:number = coordinates[i][1];
            const symbol:TeslaStateReelSymbol | null = <TeslaStateReelSymbol>Reels.getSymbol(reelIndex, symbolIndex);
            if(symbol != null) {
                const symbolAnimation:Timeline | null = TeslaSymbolUtil.getSymbolWinAnimation(symbol, winRatioConfig);
                if(symbolAnimation != null) {
                    tl.add(symbolAnimation, 0.13 * reelIndex);
                }
            }
        }
        return tl;
    }

    public static resetSymbolWinAnimation(coordinates:[number, number][]) {
        for(let i:number = 0; i < coordinates.length; i++) {
            const reelIndex:number = coordinates[i][0];
            const symbolIndex:number = coordinates[i][1];
            const symbol:TeslaStateReelSymbol | null = <TeslaStateReelSymbol>Reels.getSymbol(reelIndex, symbolIndex);
            if(symbol != null) {
                let length = symbol.children.length;
                symbol.removeChildAt(length - 1);
            }
        }
    }

    public static removeFromArrayAndSetStateToNormal(symbols:TeslaStateReelSymbol[]):void {
        while(symbols.length > 0) {
            const symbol = symbols.pop()!;
            symbol.changeState({
                state : GameConfig.instance.SYMBOL_STATES.normal
            });
        }
    }

    public static getSymbolsWithState(symbolStates:StateMatrix<string>, state:string):TeslaStateReelSymbol[] {
        const symbols:TeslaStateReelSymbol[] = [];
        const coordinates:[number, number][] = symbolStates.getAllCoordinatesWithState(state);
        for(let i:number = 0; i < coordinates.length; i++) {
            const reelIndex:number = coordinates[i][0];
            const symbolIndex:number = coordinates[i][1];
            const symbol:TeslaStateReelSymbol | null = <TeslaStateReelSymbol>Reels.getSymbol(reelIndex, symbolIndex);
            if(symbol != null) {
                symbols.push(symbol);
            }
        }

        return symbols;
    }

    public static createWinAndNoWinSymbolStateMatrix(betWinsData:IBetLineWinData[]):StateMatrix<string> {
        let states:StateMatrix<string> = new StateMatrix<string>(5, 5, [1, 3]);
        states.populate(TeslaGameConfig.instance.SYMBOL_STATES.noWin.keyword);

        for(let i:number = 0; i < betWinsData.length; i++) {
            let betLineWinData:IBetLineWinData = betWinsData[i];
            for(let j:number = 0; j < betLineWinData.nrOfSymbols; j++) {
                states.setStateAt(j, betLineWinData.betLine[j], TeslaGameConfig.instance.SYMBOL_STATES.win.keyword);
            }
        }
        return states;
    }

    public static swapReels(targetReels:string[][]) {
        //Replacing symbols to correct ones.
        for(let reelIndex = 0; reelIndex < targetReels.length; reelIndex++) {
            let reel:string[] = targetReels[reelIndex];
            for(let symbolIndex = 0; symbolIndex < reel.length; symbolIndex++) {
                let symbol:StateReelSymbol = Reels.getSymbol(reelIndex, symbolIndex)!;
                symbol.replaceWith(targetReels[reelIndex][symbolIndex], symbol.reelId);
                symbol.changeState({
                    state : GameConfig.instance.SYMBOL_STATES.normal
                });
            }
        }

        //Making sure that symbols outside are not FS ones.
        for(let reelIndex = 0; reelIndex < targetReels.length; reelIndex++) {
            let reelSymbols:(StateReelSymbol | null)[] = Reels.allSymbols(reelIndex);
            for(let symbol of reelSymbols) {
                if(symbol) {
                    if(symbol.symName == TeslaSymbols.W2) {
                        symbol.replaceWith(TeslaSymbols.W, symbol.reelId);
                    }
                    if(symbol.symName == TeslaSymbols.B2) {
                        symbol.replaceWith(TeslaSymbols.B, symbol.reelId);
                    }

                    symbol.changeState({
                        state : GameConfig.instance.SYMBOL_STATES.normal
                    });
                }
            }
        }
    }
}